import { UsageGuide } from "../productUsageGuides.types";
import { stripHtml } from "./stripHtml";

// Quill leaves "<p><br></p>" behind when the editor is cleared, so an empty
// body is not an empty string.
export const isRichTextEmpty = (html: string | null | undefined) =>
  !html || stripHtml(html).length === 0;

// A guide with no text, no video and no questions is legal but useless — the
// editor warns about it rather than refusing to save.
export const isUsageGuideEmpty = (guide: UsageGuide | null) =>
  !guide ||
  (isRichTextEmpty(guide.howToUseText) &&
    !guide.videoUrl &&
    guide.faqItems.length === 0);
